import { render } from "./module.vue?vue&type=template&id=7ad0f269"
import script from "./module.vue?vue&type=script&lang=js"
export * from "./module.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"dev/modules/custom/sds-updated/module.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ad0f269"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ad0f269', __exports__)) {
    api.reload('7ad0f269', __exports__)
  }
  
  module.hot.accept("./module.vue?vue&type=template&id=7ad0f269", () => {
    api.rerender('7ad0f269', render)
  })

}


export default __exports__